<template>
	<div v-if="visible" class="popup">
		<!-- 弹窗的内容 -->
		<div class="popup-content">
			<el-col :xs="24" :sm="24" class="elRol">
				<div class="title">下载app，闲置物品交易回收服务平台</div>
				<div class="garytitle">物品交易 七天免费 高价回收 闲置买卖</div>
				<div class="img">
					<div>
						<img :src="routineImage || '../../static/other/yundangpu.png'" class="image-class" />
					</div>
					<div style="margin-left: 2%;">
						<img :src="weixinImage ||'../../static/other/weixinsm.png'" class="image-class" />
					</div>
				</div>
				<div class="bottomTitle">您也可以在APP Store或安卓应用市场搜索《云当铺》下载</div>
			</el-col>
			<div class="close-button" @click="closePopup"><i class="el-icon-close"></i></div>
		</div>
		<!-- 关闭按钮 -->

	</div>
</template>

<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				routineImage: '',
				weixinImage: ''
			};
		},
		async mounted() {
			await this.getIndexAndFoot();
		},
		methods: {
			async getIndexAndFoot() {
				let routineImage = localStorage.getItem('routineImage');
				let weixinImage = localStorage.getItem('weixinImage');
				if (routineImage && weixinImage) {
					this.routineImage = routineImage;
					this.weixinImage = weixinImage;
				} else {
					let res = await this.util.request({
						url: `/sy/website/getIndexAndFoot`,
						method: 'GET',
						data: {},
						type: 1
					});
					if (res.status === 200) {
						this.routineImage = res.data.routineImage;
						this.weixinImage = res.data.weixinImage;
						localStorage.setItem('routineImage', this.routineImage);
						localStorage.setItem('weixinImage', this.weixinImage);
					} else {
						console.log(res.statusText);
					}
				}
			},
			closePopup() {
				this.$emit('close');
			}
		}
	}
</script>

<style lang="less" scoped>
	.elRol {
		display: flex;
		flex-direction: column;
	}

	.image-class {
		width: 120px;
		height: 120px;
		border: 0
	}

	.popup {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 100000;
	}

	.popup-content {
		background: #fff;
		padding: 20px;
		border-radius: 5px;
		width: 400px;
		position: relative;
	}

	.close-button {
		margin-top: 10px;
		position: absolute;
		right: 10px;
		top: 0;
		box-shadow: none;
		font-size: 32px;
		color: #999;
		cursor: grab;
	}

	.img {
		display: flex;
		justify-content: space-around;
	}

	.title {
		font-weight: bold;
		font-size: 20px;
		color: #504A4D;
	}

	.garytitle {
		font-size: 14px;
		color: #989898;
		padding: 10px 0 20px;
		border-bottom: solid 3px #ff9999;
		margin-bottom: 20px;
	}

	.bottomTitle {
		font-size: 14px;
		color: #504A4D;
		padding: 19px 0 7px;
	}
</style>


// WEBPACK FOOTER //
// src/components/popup.vue